import { z } from 'zod/v3'

export const PAGE_SIZE_OPTIONS = [25, 50, 100] as const
export const DEFAULT_PAGE_SIZE = 25

export const paginationSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1).optional(),
  pageSize: z.coerce
    .number()
    .int()
    .refine((v) => (PAGE_SIZE_OPTIONS as readonly number[]).includes(v), {
      message: `pageSize must be one of ${PAGE_SIZE_OPTIONS.join(', ')}`,
    })
    .catch(DEFAULT_PAGE_SIZE)
    .optional(),
})
